module.exports = __webpack_public_path__ + "static/media/list-user-search.28232dce.svg";